import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const modalContainer = css`
  display: flex;
  flex-direction: column;
`;

export const modalContent = css`
  padding: 0 var(--space-500) var(--space-500);

  font-size: initial;
  font-weight: initial;
  line-height: initial;

  ${breakpoints.only.mobile} {
    padding: 0 var(--space-200) var(--space-200);
  }
`;

export const refundInfoText = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  ${breakpoints.to.tablet} {
    margin-top: var(--space-150);
  }
`;

export const easyRefundAdvantagesContainer = css`
  display: flex;
  flex-direction: row;
  margin-top: var(--space-400);
  gap: var(--space-300);
  ${breakpoints.to.tablet} {
    flex-direction: column;
  }
`;

export const easyRefundAdvantage = css`
  padding: var(--space-200);
  border: var(--space-10) solid var(--control-minor);
  border-radius: var(--rounding-l);
  flex: 1;
  min-width: 300px;
  ${breakpoints.from.tablet} {
    min-width: 185px;
  }
`;

export const modalCustom = css`
  overflow-y: auto;
  margin: 0 !important;
  height: 526px;

  ${breakpoints.to.desktop} {
    height: 654px;
  }

  ${breakpoints.only.mobile} {
    height: 392px;
  }
`;

export const easyRefundAdvantageText = css`
  display: flex;
  flex-direction: column;
  margin-top: var(--space-200);
  gap: var(--space-100);
`;
